<div class="flex flex-column h-screen w-screen align-items-center justify-content-center">
  <div class="flex justify-content-end w-full px-3 pt-3 pb-3 sm:pb-0">
    <app-language-config></app-language-config>
  </div>
  <div class="flex flex-1 flex-column justify-content-center align-items-center w-6 gap-3">
    <img class="w-12rem h-12rem" src="assets/images/img-missing-permission.png" alt="missing-permission" />
    <p class="text-2xl text-color font-semibold">{{ 'missing_permission.header' | transloco }}</p>
    <p *appHiddenProd class="text-base text-bluegray-500 font-normal text-center">
      {{ 'missing_permission.sub_header' | transloco }}
    </p>
    <div class="w-6 mt-6">
      <p-button styleClass="flex justify-content-center w-full" (onClick)="routeToApp()">
        <p>{{ 'missing_permission.back_to_home' | transloco }}</p>
      </p-button>
    </div>
  </div>
</div>
